<script setup>
import { FormTextarea } from "@Components/Form";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
    html: String,
});

const { t: __ } = useI18n();

const currentTab = ref("html");

onMounted(() => {
    if (props.html && props.html.trim() !== "") {
        currentTab.value = "preview";
    }
});
</script>
<template>
    <div class="flex flex-col p-6 rounded-md border border-gray-200">
        <div>
            <nav class="flex space-x-4" aria-label="Tabs">
                <button
                    type="button"
                    :class="[
                        currentTab === 'html' ? 'bg-gray-100 text-gray-700' : 'text-gray-500 hover:text-gray-700',
                        'rounded-md px-3 py-2 text-sm font-medium',
                    ]"
                    @click="currentTab = 'html'">
                    {{ __("Code HTML") }}
                </button>
                <button
                    type="button"
                    :class="[
                        currentTab === 'preview' ? 'bg-gray-100 text-gray-700' : 'text-gray-500 hover:text-gray-700',
                        'rounded-md px-3 py-2 text-sm font-medium',
                    ]"
                    @click="currentTab = 'preview'">
                    {{ __("Prévisualisation") }}
                </button>
            </nav>
        </div>
        <div class="h-[32rem] mt-6">
            <FormTextarea v-if="currentTab === 'html'" :model-value="html" readonly rows="20"></FormTextarea>
            <iframe v-if="currentTab === 'preview'" :srcdoc="html" sandbox="allow-scripts" class="w-full h-full rounded" style="background: white" />
        </div>
    </div>
</template>
